// Header size change
let siteHeader = document.querySelector('.jsSiteHeader');
let siteFooter = document.querySelector('.jsSiteFooter');

let siteHeaderObserver = new ResizeObserver(siteHeaderEntries =>
{
	for (let entry of siteHeaderEntries)
	{
		let newHeight = entry.target.clientHeight;
		document.documentElement.style.setProperty('--siteHeaderHeight', newHeight + 'px');

	}
});
siteHeaderObserver.observe(siteHeader);


// Footer fits in viewport?
if (siteFooter) {
	// Classes to apply to the footer
	const footerClasses = ['sticky', 'bottom-0'];

	function checkHeaderFooterHeight() {
		let viewportHeight = window.innerHeight;
		let siteFooterHeight = siteFooter.offsetHeight;
		// console.log({viewportHeight});
		// console.log({siteFooterHeight});

		if (siteFooterHeight < viewportHeight) {
			// console.log("Stickying footer");
			siteFooter.classList.add(...footerClasses);
		} else {
			// console.log("Unstickying footer");
			siteFooter.classList.remove(...footerClasses);
		}
	}

	// Initialize ResizeObserver
	const observer = new ResizeObserver(checkHeaderFooterHeight);

	// Observe header and footer for size changes
	observer.observe(siteHeader);
	observer.observe(siteFooter);

	// Debounce function to limit frequency of resize handler calls
	let resizeTimeout;
	function debouncedResizeHandler() {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(checkHeaderFooterHeight, 100); // 100ms debounce delay
	}

	// Add resize event listener for viewport changes with debounce
	window.addEventListener('resize', debouncedResizeHandler);

	// Run check on page load
	checkHeaderFooterHeight();
}